module.exports = __webpack_public_path__ + "media/images/top-page_profile@2x-6fae4dc7d69e54a04372192e9b686edf.jpg";